import { render, staticRenderFns } from "./VideoCommunication.vue?vue&type=template&id=c98328ce&"
import script from "./VideoCommunication.vue?vue&type=script&lang=js&"
export * from "./VideoCommunication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports